import { useReferenceMap } from 'stores/useReferenceMapsStore'

import { MessageReference } from 'types/Api'

export const useFilteredOrderedReferences = (messageId: string, references: MessageReference[]) => {
  const referenceMap = useReferenceMap(messageId)

  if (!referenceMap || !references) {
    return []
  }

  return references
    .filter(reference => reference.refId && reference.refId in referenceMap)
    .map((reference) => {
      if (!reference.refId) {
        return reference
      }
      return {
        ...reference,
        order: referenceMap?.[reference.refId],
      }
    })
    .sort((a, b) => a.order - b.order)
}
